import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { TabsWithCards } from "@/patterns/tabs-with-cards/src/tabs-with-cards.pattern";

import { Integrations } from "./integrations";
import { TEAM_DATA } from "./tab-contents/team-data";

// including Integrations section here so that it can use Adg4Tabs Context
export const TabsAndIntegrationsSections = () => {
    const intl = useIntl();

    const h2Text = intl.formatMessage({
        id: "HomePageTemplateV2.tabsSection.header",
        defaultMessage: "Empower everyone, on every team"
    });

    const tabsData = TEAM_DATA.map((team) => {
        return {
            id: team.id,
            title: intl.formatMessage(team.title),
            englishLabel: team.englishLabel,
            tabComponent: team.tabComponent
        };
    });

    return (
        <UFOSegment name="homepage-v2-tabs">
            <TabsWithCards h2Text={h2Text} tabsData={tabsData}>
                <Integrations />
            </TabsWithCards>
        </UFOSegment>
    );
};

TabsAndIntegrationsSections.displayName = "TabsAndIntegrationsSections";
